import {
  HERO_IMAGE_ALT,
  HERO_IMAGE_SIZES,
  HERO_IMAGE_SRCSET,
  HERO_IMAGE_SRCSET_AVIF,
  HERO_IMAGE_SRCSET_WEBP,
  HERO_IMAGE_URL,
} from '@/lib/constants/heroImage';
import { HeroWisteriaMotion } from './HeroWisteriaMotion';

interface HeroBackdropProps {
  /** Passed to the wisteria sway: start it only after other idle work, pause it under a dialog */
  motionCanStart?: boolean;
  motionPaused?: boolean;
}

/**
 * The landing's full-bleed hero photo with its scrims: clear at the top so the couple stay bright, dark behind the
 * landing copy for text contrast. The top scrim keeps the white logo legible over the bright top of the photo. The
 * quote wizard opens as a sheet over it, so the photo is also the wizard's backdrop.
 */
export function HeroBackdrop({ motionCanStart, motionPaused }: HeroBackdropProps = {}) {
  return (
    <>
      {/* index.html preloads the AVIF srcset on "/" so the download starts before the JS bundle runs */}
      <picture>
        <source type="image/avif" srcSet={HERO_IMAGE_SRCSET_AVIF} sizes={HERO_IMAGE_SIZES} />
        <source type="image/webp" srcSet={HERO_IMAGE_SRCSET_WEBP} sizes={HERO_IMAGE_SIZES} />
        <img
          src={HERO_IMAGE_URL}
          srcSet={HERO_IMAGE_SRCSET}
          sizes={HERO_IMAGE_SIZES}
          alt={HERO_IMAGE_ALT}
          fetchPriority="high"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
      </picture>
      <HeroWisteriaMotion canStart={motionCanStart} paused={motionPaused} />
      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/65 via-50% to-black/5" />
      <div className="absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-black/45 to-transparent" />
    </>
  );
}
